import store from "@/store";
import { Chat } from "@/store/chats/types";

export const getIsChatOwner = (chatId: string): boolean => {
  const chatDetail: Chat = store.getters.GET_CONVERTED_CHAT_DETAIL(chatId);
  return !!chatDetail?.isOwner;
};
